import React from 'react';
import { Container } from 'reactstrap';
import {
    DashboardPageHeader,
    ComingSoonCard,
    ModuleLandingGrid,
    ModuleShortcutCard,
} from '../../Components/Common/DashboardKit';

/**
 * Information Technology module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Replaced the video-based <ComingSoon> with <ComingSoonCard>.
 *  - Added a "Quick links" grid pointing to the existing IT Admin
 *    pages that are already in the router (Employee Role Assignment
 *    and EPO Limit Assignment). These routes exist today and are
 *    gated by RoleProtected — we're just surfacing them on the
 *    landing page so users don't have to navigate via the sidebar.
 *  - Removed dead imports.
 *
 * Route is wrapped in <RoleProtected requireItAdmin> in allRoutes.js,
 * and the inner shortcuts go to routes that are themselves wrapped
 * in <RoleProtected requireItAdmin>, so authorization is unchanged.
 */
const IT = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-server-line"
                        eyebrow="Infrastructure"
                        title="Information Technology"
                        subtitle="Systems, accounts, and infrastructure"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Information Technology" },
                        ]}
                    />

                    {/* Quick links — surface existing IT Admin routes */}
                    <ModuleLandingGrid
                        title="Admin shortcuts"
                        icon="ri-shield-user-line"
                        description="Frequently used IT Admin tools"
                    >
                        <ModuleShortcutCard
                            icon="ri-user-settings-line"
                            label="Employee Role Assignment"
                            subtitle="Assign system roles to employees"
                            tone="primary"
                            to="/admin/employee-roles"
                        />
                        <ModuleShortcutCard
                            icon="ri-money-dollar-circle-line"
                            label="EPO Limit Assignment"
                            subtitle="Set per-user EPO approval limits"
                            tone="warning"
                            to="/admin/employee-epo-limits"
                        />
                        <ModuleShortcutCard
                            icon="ri-team-line"
                            label="Manage Departments"
                            subtitle="HR department records (IT Admin)"
                            tone="info"
                            to="/hr/departments"
                        />
                        <ModuleShortcutCard
                            icon="ri-shield-keyhole-line"
                            label="Manage Roles"
                            subtitle="System role definitions (IT Admin)"
                            tone="dark"
                            to="/hr/roles"
                        />
                    </ModuleLandingGrid>

                    <ComingSoonCard
                        icon="ri-server-line"
                        title="More IT tools are on the way"
                        message="The IT workspace will grow to include account provisioning, license tracking, and system health monitors."
                        tone="primary"
                        features={[
                            "Account provisioning requests",
                            "Software license tracking",
                            "System health dashboard",
                            "Outage history and changelog",
                        ]}
                        contact="Reach out to the IT team for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default IT;
